import Vue from 'vue'
import axios from 'axios'
export default {
    state:{
        getUrl(){
            const instance = axios.create({
                // baseURL: 'http://10.2.210.211:30308'
                baseURL : Vue.config['url']
            });
            //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
            return instance
        }
    },
    getCampaignList(){
        return this.state.getUrl().get('/track/campaignList')
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    }
}